import http from "@/libs/http";
const directory = {
  directoryGamePageList: DirectoryPageListVO => {
    return http.get(http.formatUrl("dict/directory/game/pagelist"), DirectoryPageListVO);
  }
};
export default directory;
